import { useTheme } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

import Icon from "ui/atom/Icon";


Accordion.Details = MuiAccordionDetails;

/* variant: "default | reverse" */
Accordion.Summary = ({ variant = "default", icon = "chevron-right", ...props }) => {
	const theme = useTheme();
	const reverse = variant === "reverse";

	const style = {
		root: {
			gap: 1,
			flexDirection: reverse ? "row-reverse" : "row",
			"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": !reverse ? { transform: "rotate(90deg)" } : undefined
		},
		head: reverse ? {
			minHeight: "auto",
			fontFamily: "franklin-gothic-urw, sans-serif",
			fontSize: "17px",
			fontWeight: 700
		} : {},
		content: reverse ? {
			gap: 1,
			alignItems: "center",
			color: "text.secondary",
			m: theme.spacing(2, 0)
		} : {}
	};

	const config = {
		size: reverse ? 33 : 15,
		color: reverse ? theme.palette.text.secondary : theme.palette.accordion.icon
	};

	return (
		<MuiAccordionSummary
			expandIcon={icon && <Icon name={icon} size={config.size} color={config.color} />}
			{...props}
			slotProps={{
				...props.slotProps,
				root: { sx: { ...style.root, ...style.head, ...props.slotProps?.root?.sx } },
				content: { sx: style.content }
			}}
		/>
	);
};

export default function Accordion(props) {
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: 1,
			boxShadow: "none"
		}
	};

	return <MuiAccordion {...props} sx={{ ...style.root, ...props.sx }} />;
}